<template>
  <div>
    <StudentHistory :studentSieId="studentSieId" read-only/>
  </div>
</template>

<script>
import StudentHistory from '@/components/pei/PeiHistory';
export default {
    name: 'StudentPei',
    components:{
      StudentHistory
    },
    props:{
      studentSieId:{
          type: String,
          required: true,
          default: () => ''
      }
    }
}
</script>

<style>

</style>